import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import UploadButtonComponent from 'components/core/image_upload_button';
import { FormatsHint } from './formats_hint';
const imageUploadButtonCss = "i1vmomeb";
const ImageUploadButton = forwardRef((props, ref) => <UploadButtonComponent ref={ref} {...props} className={classNames(imageUploadButtonCss, props.className)} />);
const containerIsTabletUpCss = "cihpifi";
const containerCss = "c15plo95";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
export const UploadControl = forwardRef((props, ref) => {
  const {
    onFileSelect,
    onFileError,
    isAdminIA,
    ...restProps
  } = props;
  return <Container ref={ref} {...restProps}>
      {isAdminIA && <FormatsHint isAdminIA />}
      <ImageUploadButton onFileError={onFileError} onFileSelect={onFileSelect} decoration="secondary-outline" size="small" validate>
        {I18n.t('publisher.account_settings.branding.upload_image')}
      </ImageUploadButton>
      {!isAdminIA && <FormatsHint />}
    </Container>;
});

require("./upload_control.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./upload_control.js");